import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    FRONT_ABONADOS_BUSCAR_REFERIDO: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonados.buscar.referido'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ABONADOS_CONFIRMAR_REFERIDO: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonados.confirmar.referido'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ABONADOS_COMPRA_CALCULAR_PLAZOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonados.compra.calcular.plazos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ABONADOS_COMPRA_TERMINOS_Y_CONDICIONES: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonados.compra.terminos-y-condiciones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    LFP_ABONO_GUARDAR_DOCUMENTACION: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('lfp.abono.guardar.documentacion'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },

    FRONT_COMPROBAR_DATOS_COMPRADOR_DNI: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.comprobar.datos.comprador.dni'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ABONADOS_COMPRA_VOUCHER: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonados.compra.voucher'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ABONADOS_DESCARGAR_WALLET: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonados.descargar.wallet'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_GUARDAR_DATOS_ABONOS_SIN_RECINTO: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.guardar.datos.abonos.sin.recinto'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_TAQUILLA_DELETE_SESSION: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.taquilla.delete.session'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }    
}

export default {
    actions
};
